@import '~style-sheet-helpers/core.less';
@import '../../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../../constants/spacing.module.less';

.centered-cell {
  display: flex;
  justify-content: center;
}

.item-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: 0;
}

.item-name {
  font-weight: 600;
  color: var(--grey-900);
  overflow-wrap: break-word;
  align-items: center;
}

.item-name-link {
  text-align: left;
  overflow-wrap: break-word;
  line-height: 1.5;
}

.item-name-verified-icon {
  height: 16px;
  color: var(--green-500);
  font-size: 18px;
}

.item-sku,
.item-upc {
  font-size: 12px;
  color: var(--grey-600);
  overflow-wrap: break-word;
  align-items: center;
}
